export default __webpack_public_path__ + "static/hero.dark-eaf5c66316cd07bca6b4bd876823c88d55cde508808cdf7bc982ed9cfba91fb9.png";